import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LcsCallStatePipeModule } from '@lcs/shared/call-state-pipe';
import { LcsLoadingOverlayModule } from '@lcs/shared/loading-overlay';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { EntitySelectModule } from 'src/app/common-components/entity-select/entity-select.module';
import { AddDepartmentComponent } from './containers/add-department.component';
import { AddDepartmentEffects } from './state/add-department.effects';
import * as fromAddDepartment from './state/add-department.reducer';
import { AddDepartmentViewComponent } from './views/add-department-view.component';

@NgModule({
   declarations: [AddDepartmentViewComponent, AddDepartmentComponent],
   imports: [
      CommonModule,
      FormsModule,
      MatFormFieldModule,
      ReactiveFormsModule,
      MatCheckboxModule,
      MatInputModule,
      MatButtonModule,
      MatFormFieldModule,
      MatTooltipModule,
      MatSelectModule,
      MatDialogModule,
      LcsLoadingOverlayModule,
      LcsCallStatePipeModule,
      MatIconModule,
      MatDialogModule,
      EntitySelectModule,
      StoreModule.forFeature(fromAddDepartment.addDepartmentFeatureKey, fromAddDepartment.reducer),
      EffectsModule.forFeature([AddDepartmentEffects]),
   ],
})
export class AddDepartmentModule {}
